import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { TableCell, TableRow } from '@/components/ui/table'
import { CobaltProviderHours } from './CobaltProviderHours'
import type { CobaltProvider, CobaltProviderDay } from './types'

interface Props {
  provider: CobaltProvider
  defaultHours: CobaltProviderDay[]
  pendingStatus?: CobaltProvider['status']
  locked: boolean
  showIdentifiers: boolean
  onChange: (status: CobaltProvider['status']) => void
}

export function CobaltProviderRow({
  provider,
  defaultHours,
  pendingStatus,
  locked,
  showIdentifiers,
  onChange,
}: Props) {
  const active = (pendingStatus ?? provider.status) === 'active'
  const missingHours = !provider.hours?.length
  return (
    <TableRow>
      <TableCell className="align-top whitespace-normal">
        <Label
          htmlFor={`cobalt-provider-${provider.id}`}
          className="flex items-start gap-2 font-normal leading-normal text-foreground">
          <Checkbox
            id={`cobalt-provider-${provider.id}`}
            className="mt-0.5"
            aria-label={`Sync ${provider.name}`}
            checked={active}
            disabled={locked}
            onCheckedChange={(checked) =>
              onChange(checked === true ? 'active' : 'inactive')
            }
          />
          <span>
            <span className="font-medium">{provider.name}</span>
            {showIdentifiers && (
              <span className="block text-xs text-muted-foreground">
                EHR ID {provider.ehr_id}
                {provider.npi && ` · NPI ${provider.npi}`}
              </span>
            )}
          </span>
        </Label>
        {provider.hide_in_availability && (
          <p className="mt-1 text-xs text-muted-foreground">
            Hidden from availability
          </p>
        )}
      </TableCell>
      <TableCell className="align-top whitespace-normal text-xs text-muted-foreground">
        {missingHours && defaultHours.length > 0 ? (
          active ? (
            'Will use default'
          ) : (
            'Default on activation'
          )
        ) : provider.hours?.length ? (
          <CobaltProviderHours hours={provider.hours} />
        ) : (
          <span className="block">No schedule</span>
        )}
      </TableCell>
    </TableRow>
  )
}
